import AccessListItem from "@components/Accesses/components/AccessListItem";
import LFlatList from "@components/LFlatList";
import LScreen from "@components/LScreen";
import LText from "@components/LText";
import { useAllAccessesPaginated } from "@hooks/trpc/useAccesses";
import { theme } from "@theme";
import { ActivityIndicator } from "react-native";
import LoadingScreen from "@components/LoadingScreen";

export const AllAccessesScreen = () => {
  const {
    data: allAccesses,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useAllAccessesPaginated();

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <LScreen enableAutomaticTopPadding={true}>
      <LFlatList
        contentContainerStyle={{ rowGap: theme.spacing.s3 }}
        data={allAccesses ?? []}
        ListHeaderComponent={() => <LText variant="listItem">Upcoming</LText>}
        renderItem={({ item }) => <AccessListItem access={item} />}
        showsVerticalScrollIndicator={false}
        onEndReached={() => {
          if (hasNextPage && !isFetchingNextPage) {
            fetchNextPage().catch(console.error);
          }
        }}
        onEndReachedThreshold={0.35}
        ListFooterComponent={
          isFetchingNextPage ? (
            <ActivityIndicator
              size="large"
              style={{ paddingBottom: theme.spacing.s4 }}
            />
          ) : null
        }
      />
    </LScreen>
  );
};
